import { defineField, defineType } from "sanity";

export const favoritesPage = defineType({
  name: "favoritesPage",
  title: "Favorites Page",
  type: "document",
  groups: [
    { name: "content", title: "Content", default: true },
    { name: "labels", title: "Labels" },
    { name: "seo", title: "SEO" }
  ],
  fields: [
    // ── Content ────────────────────────────────────────────────────────
    defineField({
      name: "heroImage",
      title: "Hero image",
      type: "image",
      description: "Hero image at the top of the Favorites page.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "content"
    }),
    defineField({
      name: "heading",
      title: "Page heading",
      type: "string",
      description: "Main heading (e.g. 'YOUR FAVORITES').",
      group: "content"
    }),
    defineField({
      name: "subtitle",
      title: "Subtitle",
      type: "text",
      rows: 2,
      description: "Supporting copy shown when there are favorite items.",
      group: "content"
    }),
    defineField({
      name: "emptyMessage",
      title: "Empty favorites message",
      type: "text",
      rows: 3,
      description: "Text shown when there are no favorites.",
      group: "content"
    }),
    defineField({
      name: "browseButtonText",
      title: "Browse button text",
      type: "string",
      description: "Text on the browse button shown when empty (e.g. 'Browse the collection').",
      group: "content"
    }),
    defineField({
      name: "browseButtonLink",
      title: "Browse button link",
      type: "string",
      description: "Link for the browse button (e.g. '/browse').",
      group: "content"
    }),
    defineField({
      name: "contactButtonText",
      title: "Contact button text",
      type: "string",
      description: "Text on the contact to purchase button (e.g. 'Contact to purchase').",
      group: "content"
    }),

    // ── Labels ─────────────────────────────────────────────────────────
    defineField({
      name: "addToBagText",
      title: "Add to bag text",
      type: "string",
      description: "Text on the add to bag button (e.g. 'Add to bag').",
      group: "labels"
    }),
    defineField({
      name: "inBagText",
      title: "In bag text",
      type: "string",
      description: "Text shown when an item is already in the bag (e.g. 'In bag').",
      group: "labels"
    }),
    defineField({
      name: "soldOutText",
      title: "Sold out text",
      type: "string",
      description: "Text shown when an item is sold out (e.g. 'Sold out').",
      group: "labels"
    }),
    defineField({
      name: "removeText",
      title: "Remove text",
      type: "string",
      description: "Text on the remove button (e.g. 'Remove').",
      group: "labels"
    }),

    // ── SEO ────────────────────────────────────────────────────────────
    defineField({
      name: "metaTitle",
      title: "Meta title",
      type: "string",
      description: "Page title for search engines.",
      group: "seo"
    }),
    defineField({
      name: "metaDescription",
      title: "Meta description",
      type: "text",
      rows: 3,
      description: "Short description for search engines.",
      group: "seo"
    }),
    defineField({
      name: "ogImage",
      title: "Sharing image",
      type: "image",
      description: "Image shown when this page is shared on social media.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "seo"
    })
  ],
  preview: {
    prepare: () => ({
      title: "Favorites Page"
    })
  }
});
